import { ENGINE_MOVETIME_FAST_MS, ENGINE_MOVETIME_SLOW_MS, MAX_FULL_MOVES } from '../constants';

export function selectEnginePolicy(fullMoveCount, chessInstance) {
  // Speed up when opponent has only a king
  if (opponentHasOnlyKing(chessInstance)) {
    return { type: 'movetime', value: ENGINE_MOVETIME_FAST_MS };
  }
  if (fullMoveCount < 100) {
    return { type: 'movetime', value: ENGINE_MOVETIME_SLOW_MS };
  }
  if (fullMoveCount <= MAX_FULL_MOVES) {
    return { type: 'movetime', value: ENGINE_MOVETIME_FAST_MS };
  }
  return { type: 'forceDraw' };
}

export function shouldForceDraw(fullMoveCount) {
  return fullMoveCount >= MAX_FULL_MOVES;
}

export function getFullMoveCount(chessInstance) {
  try { return chessInstance?.history()?.length ? Math.ceil(chessInstance.history().length / 2) : 0; } catch (_) { return 0; }
}

export function sideHasOnlyKing(chessInstance, color) {
  try {
    const board = chessInstance?.board?.();
    if (!board) return false;
    let pieceCount = 0;
    for (let r = 0; r < board.length; r++) {
      const row = board[r] || [];
      for (let c = 0; c < row.length; c++) {
        const piece = row[c];
        if (piece && piece.color === color) {
          pieceCount += 1;
          if (piece.type !== 'k') return false;
        }
      }
    }
    return pieceCount === 1; // only the king
  } catch (_) {
    return false;
  }
}

export function opponentHasOnlyKing(chessInstance) {
  try {
    const turn = chessInstance?.turn?.();
    const opponent = turn === 'w' ? 'b' : 'w';
    return sideHasOnlyKing(chessInstance, opponent);
  } catch (_) {
    return false;
  }
}

